// Simplified SendByRequest.js
import React, { useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom"
import axios from "axios"
import toastr from "toastr"
import "toastr/build/toastr.min.css"
import Select from "react-select"
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  CardBody,
  Button,
  CardTitle,
  Label,
  Input,
  FormGroup,
  Form,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import apiURl from "url" // Make sure this is correctly imported
import { lowerCase } from "lodash"
import { faL } from "@fortawesome/free-solid-svg-icons"

const SendByRequest = () => {
  document.title = "Courier Info"
  const { id } = useParams()
  const navigate = useNavigate()
  const [formData, setFormData] = useState({})
  const [documentMode, setDocumentMode] = useState(false)
  const [riderOptions, setRiderOptions] = useState([])
  const [paymentOptions, setPaymentOptions] = useState([])
  const [selectedRider, setSelectedRider] = useState(null)
  const [selectedPayment, setSelectedPayment] = useState(null)
  const [riderCharges, setRiderCharges] = useState(100)
  const [paymentStatus, setPaymentStatus] = useState("not-paid")
  const [includeCVI, setIncludeCVI] = useState(false)
  const [totals, setTotals] = useState({
    subServicesTotal: 0,
    childServicesTotal: 0,
    grandTotal: 0,
    cviAmount: 0,
    finalTotal: 0,
  })

  const login_user_id = localStorage.getItem("login_user_id")
  const role = localStorage.getItem("role")

  useEffect(() => {
    if (formData.doc_details) {
      calculateTotals()
    }
  }, [formData, includeCVI, riderCharges, totals])

  const deliveryOptionsMap = {
    wc: "Within City",
    sz: "Same Zone",
    dz: "Diff Zone",
  }

  const getDeliveryOptionValue = () => {
    if (documentMode) {
      return formData.delivery_option_2
    } else {
      return deliveryOptionsMap[formData.req_delivery_options] || ""
    }
  }

  const deliveryNote = () => {
    const option = getDeliveryOptionValue()
    if (option === "Within City") {
      return (
        <>
          This rider will handle both pickup and delivery because the Sector is{" "}
          <strong>{option}</strong>.
        </>
      )
    } else if (option === "Same Zone" || option === "Diff Zone") {
      return (
        <>
          This rider will pick up the parcel and submit it to ECS for further
          delivery because the Sector is <strong>{option}</strong>.
        </>
      )
    } else {
      return ""
    }
  }

  //
  //Fetch Services Detial
  const fetchSubServiceChargesData = (MS, SS, SC, PW) => {
    let zone = SC
    if (SC == "within City") {
      zone = "wc"
    } else if (SC == "Same Zone") {
      zone = "sz"
    } else if (SC == "Diff Zone") {
      zone = "dz"
    }
    SS = lowerCase(SS)
    const URL = `${apiURl}/fetchServiceChargesData`
    axios
      .get(URL)
      .then(response => {
        if (response.data.status === "success") {
          const serviceChargesData = response.data.serviceChargesData
          if (serviceChargesData.length > 0) {
            // Find the selected service object for the provided weight
            let selectedServiceCharges = serviceChargesData.find(service => {
              return (
                service.sub_service === SS &&
                service.service_sector === zone &&
                service.parcel_weight === PW
              )
            })

            // If service charges for the provided weight are not found, fall back to default weight (1 kg)

            if (!selectedServiceCharges && PW !== "1") {
              selectedServiceCharges = serviceChargesData.find(service => {
                return (
                  service.sub_service === SS &&
                  service.service_sector === zone &&
                  service.parcel_weight === "1" // Fall back to default weight (1 kg)
                )
              })
            }

            // For Box
            let totalServiceCharges = 0
            if (selectedServiceCharges) {
              totalServiceCharges = parseFloat(
                selectedServiceCharges.service_charges
              )

              // Check if the weight is greater than 1 kg and calculate additional charges
              if (PW > 1) {
                const extraWeightCharges = parseFloat(
                  selectedServiceCharges.extra_weight_charges
                )
                totalServiceCharges += extraWeightCharges * (PW - 1) // Calculate additional charges for each additional kg
              }

              // Apply urgency charges if applicable
              if (MS === "Urgent") {
                totalServiceCharges += 100
              }
            } else {
              console.error(
                "No service charges found for the provided weight or default weight."
              )
            }
            setTotals(prevData => ({
              ...prevData,
              grandTotal: totalServiceCharges,
            }))
          } else {
            console.error("No service data found")
          }
        } else {
          console.error("Failed to fetch service data:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching service data:", error)
      })
  }
  //Calclation
  const calculateTotals = () => {
    if (documentMode) {
      // Calculate for document mode
      const mainServices = formData.doc_details.mainServices || []
      const childServices = formData.doc_details.childServices || []
      const cvi_amount = formData.cvi_amount || null

      const subServicesTotal = mainServices.reduce(
        (sum, item) => sum + (parseFloat(item.subtotal) || 0),
        0
      )
      const childServicesTotal = childServices.reduce(
        (sum, item) => sum + (parseFloat(item.subtotal) || 0),
        0
      )

      if (cvi_amount !== null) {
        setIncludeCVI(true)
      } else {
        setIncludeCVI(false)
      }

      const grandTotal = subServicesTotal + childServicesTotal
      const cviAmount = includeCVI ? cvi_amount * 0.025 : 0
      const finalTotal = grandTotal + cviAmount + parseFloat(riderCharges || 0)

      setTotals({
        subServicesTotal,
        childServicesTotal,
        grandTotal,
        cviAmount,
        finalTotal,
      })
    } else {
      const CVIamount = formData.content_value || null
      if (CVIamount !== null) {
        setIncludeCVI(true)
      } else {
        setIncludeCVI(false)
      }
      const cviAmount = includeCVI ? CVIamount * 0.025 : 0

      const finalTotal =
        totals.grandTotal + cviAmount + parseFloat(riderCharges || 0)

      setTotals(prevData => ({
        ...prevData,
        subServicesTotal: 0,
        childServicesTotal: 0,
        cviAmount,
        finalTotal,
      }))
    }
  }
  //All Requests

  const fetchRequest = async () => {
    try {
      const res = await axios.get(`${apiURl}/singlerequests/${id}`)

      if (res.data.status === "success") {
        const req = res.data.data
        const isDocumentMode = req.req_service_name == "Docs. Attestation"
        setDocumentMode(isDocumentMode)

        if (isDocumentMode) {
          const deliveryOptions = req.req_delivery_options
            ? JSON.parse(req.req_delivery_options)
            : {}
          const locationAttributes = req.location_atributes
            ? JSON.parse(req.location_atributes)
            : {}
          const docsDetails = req.docs_details
            ? JSON.parse(req.docs_details)
            : {}

          setFormData({
            service_name: req.req_service_name,
            sub_service_name: docsDetails,
            delivery_option_1: deliveryOptions.deliveryOption1 || "",
            delivery_option_2: deliveryOptions.deliveryOption2 || "",
            sender_name: req.req_sender_name,
            sender_phone: req.req_sender_mobile,
            sender_address: req.req_sender_address,
            receiver_name: req.req_receiver_name,
            receiver_phone: req.req_receiver_mobile,
            receiver_address: req.req_receiver_address,
            pickup_location: req.pickup_location,
            from_city: locationAttributes.from_city || "",
            to_city: locationAttributes.to_city || "",
            doc_details: docsDetails,
            no_of_docs: req.number_of_docs,
            weight: req.weight,
            cvi_amount: req.cvi_amount,
          })
          fetchUsers()
        } else {
          setFormData({
            service_name: req.req_service_name,
            sub_service_name: req.req_sub_service,
            req_delivery_options: req.req_delivery_options,
            content_value: req.no_of_pages,
            sender_name: req.req_sender_name,
            sender_phone: req.req_sender_mobile,
            sender_address: req.req_sender_address,
            receiver_name: req.req_receiver_name,
            receiver_phone: req.req_receiver_mobile,
            receiver_address: req.req_receiver_address,
            pickup_location: req.pickup_location,
            doc_details: req.docs_details,
            no_of_docs: req.number_of_docs,
            weight: req.weight,
            cvi_amount: req.cvi_amount,
          })
          fetchUsers()
          fetchSubServiceChargesData(
            req.req_service_name,
            req.req_sub_service,
            req.req_delivery_options,
            req.weight
          )
        }
      }
    } catch (error) {
      console.error("Error fetching request:", error)
    }
  }
  //Fetch Users
  const fetchUsers = () => {
    const URL = `${apiURl}/fetchUsers`
    axios
      .get(URL)
      .then(response => {
        if (response.data.status === "success") {
          const Data = response.data.users
          const UserData = Data.filter(item => item.user_id === login_user_id)
          if (UserData) {
            setFormData(prevData => ({
              ...prevData,
              employee_name: UserData[0].full_name,
              employee_id: UserData[0].user_id,
              employee_city: UserData[0].city_,
            }))
          } else {
            setFormData(prevData => ({
              ...prevData,
            }))
          }
        } else {
          console.error("Failed to fetch users:", response.data.message)
        }
      })
      .catch(error => {
        console.error("Error fetching users:", error)
      })
  }

  // Fetch riders data
  const getApprovedRiders = async () => {
    try {
      const URL = `${apiURl}/getApprovedRiders`
      const response = await axios.get(URL)

      if (response.data.status === "success") {
        const rideroption = response.data.riders.map(row => ({
          label: row.name,
          value: row.id,
        }))
        setRiderOptions(rideroption)
      } else {
        console.error("Failed to fetch riders:", response.data.message)
      }
    } catch (error) {
      console.error("Error fetching riders:", error)
    }
  }
  //Payment
  const fetchPaymentMethods = () => {
    axios.get(`${apiURl}/fetchPaymentMethod`).then(res => {
      if (res.data.status === "success") {
        const options = res.data.PMethod.map(p => ({
          label: p.method_name,
          value: p.method_name,
        }))
        setPaymentOptions(options)
      }
    })
  }
  //Main submit
  const handleSubmit = async () => {
    if (!selectedRider) {
      toastr.error("Please select a rider")
      return
    }

    if (!selectedPayment) {
      toastr.error("Please select a prefer payment method")
      return
    }

    const payload = {
      ...formData,
      request_id: id,
      assign_to: selectedRider.value,
      payment_method: selectedPayment?.value,
      total_amount: totals.finalTotal,
      cvi_included: includeCVI,
      rider_charges: riderCharges,
      paymentStatus,
    }

    try {
      const res = await axios.post(`${apiURl}/proceedFromRequest`, payload)
      if (res.data.status === "success") {
        toastr.success("Parcel added successfully")
        navigate("/today_book")
      } else {
        toastr.error("Failed to add parcel")
      }
    } catch (err) {
      console.error("Submission error:", err)
      toastr.error("Server error")
    }
  }

  useEffect(() => {
    fetchRequest()
    getApprovedRiders()
    fetchPaymentMethods()
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs breadcrumbItem="Send By Request" />
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">
                    Sender & Receiver Information
                  </CardTitle>

                  <div className="mb-4">
                    <Row>
                      <Col md={6}>
                        <div className="border p-3 mb-3 rounded">
                          <h5 className="font-size-14 mb-3">Sender Details</h5>
                          <div className="mb-2">
                            <label className="form-label">Name</label>
                            <Input
                              value={formData.sender_name || ""}
                              disabled
                              className="bg-light"
                            />
                          </div>
                          <div className="mb-2">
                            <label className="form-label">Phone</label>
                            <Input
                              value={formData.sender_phone || ""}
                              disabled
                              className="bg-light"
                            />
                          </div>
                          <div>
                            <label className="form-label">Address</label>
                            <Input
                              value={formData.sender_address || ""}
                              disabled
                              className="bg-light"
                              type="textarea"
                              rows="2"
                            />
                          </div>
                        </div>
                      </Col>

                      <Col md={6}>
                        <div className="border p-3 mb-3 rounded">
                          <h5 className="font-size-14 mb-3">
                            Receiver Details
                          </h5>
                          <div className="mb-2">
                            <label className="form-label">Name</label>
                            <Input
                              value={formData.receiver_name || ""}
                              disabled
                              className="bg-light"
                            />
                          </div>
                          <div className="mb-2">
                            <label className="form-label">Phone</label>
                            <Input
                              value={formData.receiver_phone || ""}
                              disabled
                              className="bg-light"
                            />
                          </div>
                          <div>
                            <label className="form-label">Address</label>
                            <Input
                              value={formData.receiver_address || ""}
                              disabled
                              className="bg-light"
                              type="textarea"
                              rows="2"
                            />
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>

                  {documentMode && formData.doc_details?.mainServices && (
                    <div className="mb-4">
                      <CardTitle className="mb-3">
                        Document Details For{" "}
                        <span style={{ color: "blue" }}>
                          {formData.service_name}
                        </span>{" "}
                        Service
                      </CardTitle>
                      <div className="table-responsive">
                        <Table className="table-bordered table-nowrap">
                          <thead className="table-light">
                            <tr>
                              <th>Service Type</th>
                              <th>Description</th>
                              <th>Quantity</th>
                              <th>Unit Price</th>
                              <th>Subtotal</th>
                            </tr>
                          </thead>
                          <tbody>
                            {formData.doc_details.mainServices.map((doc, i) => (
                              <tr key={`main-${i}`}>
                                <td>Sub Service</td>
                                <td>{doc.label}</td>
                                <td>{doc.quantity}</td>
                                <td>{doc.unitPrice}</td>
                                <td>{doc.subtotal}</td>
                              </tr>
                            ))}
                            {formData.doc_details.childServices?.map(
                              (doc, i) => (
                                <tr key={`child-${i}`}>
                                  <td>Add. Apostille Service</td>
                                  <td>{doc.label}</td>
                                  <td>{doc.quantity}</td>
                                  <td>{doc.unitPrice}</td>
                                  <td>{doc.subtotal}</td>
                                </tr>
                              )
                            )}
                          </tbody>
                        </Table>
                      </div>
                    </div>
                  )}

                  {!documentMode && (
                    <div className="mb-4">
                      <CardTitle className="mb-3">Parcel Details</CardTitle>
                      <Row>
                        <Col md={4}>
                          <div className="border p-3 mb-3 rounded">
                            <h6 className="font-size-13">
                              Service Information
                            </h6>
                            <div className="mb-2">
                              <label className="form-label">Service</label>
                              <Input
                                value={formData.service_name || ""}
                                disabled
                                className="bg-light"
                              />
                            </div>
                            <div className="mb-2">
                              <label className="form-label">Sub Service</label>
                              <Input
                                value={formData.sub_service_name || ""}
                                disabled
                                className="bg-light"
                              />
                            </div>
                            <div>
                              <label className="form-label">Sector</label>
                              <Input
                                value={
                                  deliveryOptionsMap[
                                    formData.req_delivery_options
                                  ] || ""
                                }
                                disabled
                                className="bg-light"
                              />
                            </div>
                          </div>
                        </Col>
                        <Col md={4}>
                          <div className="border p-3 mb-3 rounded">
                            <h6 className="font-size-13">Parcel Information</h6>
                            <div className="mb-2">
                              <label className="form-label">Quantity</label>
                              <Input
                                value={formData.no_of_docs || ""}
                                disabled
                                className="bg-light"
                              />
                            </div>
                            <div className="mb-2">
                              <label className="form-label">Weight</label>
                              <Input
                                value={formData.weight || ""}
                                disabled
                                className="bg-light"
                              />
                            </div>
                            {formData.content_value !== 0 && (
                              <div>
                                <label className="form-label">
                                  Content Value
                                </label>
                                <Input
                                  value={formData.content_value}
                                  disabled
                                  className="bg-light"
                                />
                              </div>
                            )}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  )}

                  <div className="mb-4">
                    <CardTitle className="mb-3">Pricing Summary</CardTitle>
                    <div className="border p-3 rounded">
                      {documentMode && (
                        <>
                          <div className="d-flex justify-content-between mb-2">
                            <span>Main Services Subtotal:</span>
                            <span>{totals.subServicesTotal.toFixed(2)}</span>
                          </div>
                          <div className="d-flex justify-content-between mb-2">
                            <span>Additional Services Subtotal:</span>
                            <span>{totals.childServicesTotal.toFixed(2)}</span>
                          </div>

                          <div className="d-flex justify-content-between mb-2 font-weight-bold">
                            <span>Subtotal:</span>
                            <span>{totals.grandTotal.toFixed(2)}</span>
                          </div>
                        </>
                      )}
                      {!documentMode && (
                        <div className="d-flex justify-content-between mb-2 font-weight-bold">
                          <span>Base Amount:</span>
                          <span>{totals.grandTotal.toFixed(2)}</span>
                        </div>
                      )}
                      <div className="d-flex justify-content-between mb-2">
                        <span>Rider Charges:</span>
                        <span>
                          + {parseFloat(riderCharges || 0).toFixed(2)}
                        </span>
                      </div>
                      {includeCVI && (
                        <div className="d-flex justify-content-between mb-2">
                          <div className="d-flex align-items-center">
                            <label htmlFor="includeCVI" className="mb-0">
                              ✔️ CVI Included (2.5%)
                            </label>
                          </div>
                          <span>+ {totals.cviAmount.toFixed(2)}</span>
                        </div>
                      )}

                      <hr />
                      <div className="d-flex justify-content-between font-weight-bold text-primary">
                        <span>Total Amount:</span>
                        <span>{totals.finalTotal.toFixed(2)}</span>
                      </div>
                    </div>
                  </div>

                  <div className="mb-4">
                    <CardTitle className="mb-3">Assignment & Payment</CardTitle>
                    <Row>
                      <Col md={4}>
                        <div className="mb-3">
                          <label className="form-label">
                            Assign To Rider *
                          </label>

                          <Select
                            options={riderOptions}
                            onChange={setSelectedRider}
                          />
                          <small className="text-danger d-block">
                            {deliveryNote()}
                          </small>
                        </div>
                      </Col>
                      <Col md={2}>
                        <div className="mb-3">
                          <label className="form-label">Rider Charges *</label>
                          <Input
                            type="number"
                            value={riderCharges}
                            onChange={e => {
                              setRiderCharges(e.target.value)
                            }}
                            onWheel={e => e.target.blur()}
                            min="0"
                          />
                          <small className="text-danger d-block">
                            Based on Pick & Drop <strong>Locations</strong>
                          </small>
                        </div>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label>Payment Status</Label>
                          <Input
                            type="select"
                            value={paymentStatus}
                            onChange={e => setPaymentStatus(e.target.value)}
                          >
                            <option value="paid">Paid</option>
                            <option value="not-paid" selected>
                              Not Paid
                            </option>
                          </Input>
                        </FormGroup>
                      </Col>

                      <Col md={3}>
                        <div className="mb-3">
                          <label className="form-label">
                            Prefer Payment Method *
                          </label>
                          <Select
                            options={paymentOptions}
                            onChange={setSelectedPayment}
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <div className="d-flex justify-content-end">
                    <Button
                      color="primary"
                      className="me-2"
                      onClick={() => navigate(-1)}
                    >
                      Back
                    </Button>
                    <Button color="success" onClick={handleSubmit}>
                      <i className="bx bx-check-double font-size-16 align-middle me-2"></i>
                      Approve Request
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default SendByRequest
